import { getNewPlatformIcon } from '@/widgets/components/online-platform-icon';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface IPositions {
  top: string;
  left?: string;
  right?: string;
}

interface IIconsOuterWrapper extends IPositions {
  children: ReactNode;
  className?: string;
}

const IconsOuterWrapper = styled.div<IIconsOuterWrapper>`
  display: flex;
  align-items: center;
  height: 24px;
  border-radius: 2px;
  backdrop-filter: blur(2px);
  background-color: rgba(255, 255, 255, 0.85);
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  right: ${(props) => props.right};
`;

const IconsInnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14px;
  margin: 0px 3px;
`;

const IconSizer = styled.div`
  width: 14px;
  height: 14px;
  margin: 0px 3px;
`;

interface Props {
  onlinePlatforms: string[];
  positions: IPositions;
  className?: string;
  platformIcons?: string[];
}

export function PropertyPlatforms({
  onlinePlatforms,
  positions,
  className,
  platformIcons,
}: Props) {
  // PREFERABLY, pass a classname to this component and style it inside a wrapper styled component
  // TODO: remove the positions prop if not necessary. Remove this comment once resolved
  return (
    <IconsOuterWrapper
      className={className}
      top={positions.top}
      left={positions.left}
      right={positions.right}
    >
      <IconsInnerWrapper>
        {onlinePlatforms.map((platform, idx) => {
          const Icon = getNewPlatformIcon(platform, platformIcons);
          return (
            <IconSizer key={`${idx}-${platform}`}>
              <Icon showTooltip />
            </IconSizer>
          );
        })}
      </IconsInnerWrapper>
    </IconsOuterWrapper>
  );
}
